import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressBarComponent} from './progress-bar.component';
import {MilestoneComponent} from './milestone/milestone.component';

@NgModule({
  declarations: [ProgressBarComponent, MilestoneComponent],
  imports: [
    CommonModule
  ],
  exports: [
    ProgressBarComponent,
    MilestoneComponent
  ]
})
export class ProgressBarModule {
}
